import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  CircularProgress,
  Box,
} from "@mui/material";

const btnStyles = {
  borderRadius: "8px",
  padding: "8px 16px",
  color: "#fff",
  fontWeight: 500,
  fontSize: 15,
  boxShadow: "none !important",
  textWrap: "nowrap",
  textTransform: "none",
};

const ConfirmationDialog = ({
  title,
  actionType,
  text,
  okText,
  cancelText,
  handleOpen,
  open,
  handleClose,
  confirmModalLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          maxWidth: "550px",
          width: "100%",
          borderRadius: "12px",
          margin: "16px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #EAEAEA",
          padding: { xs: "8px", sm: "16px" },
          paddingLeft: { xs: "16px", sm: "24px" },
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            lineHeight: "20px",
            color: "rgba(47, 43, 61, 0.9)",
          }}
        >
          {title}
        </Typography>

        <IconButton onClick={handleClose}>
          <img src="/cancel_icon.svg" alt="close" />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          padding: { xs: "16px", sm: "24px" },
        }}
      >
        <Typography
          id="dialog-description"
          sx={{
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "28px",
            color: "rgba(47, 43, 61, 0.9)",
          }}
        >
          {text}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          padding: { xs: "0px 16px 12px", sm: "0px 24px 12px" },
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            ...btnStyles,
            backgroundColor: "rgba(128, 131, 144, 1)",
          }}
        >
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={handleOpen}
          disabled={confirmModalLoading}
          sx={{
            ...btnStyles,
            backgroundColor:
              actionType === "cancel"
                ? "rgba(183, 72, 74, 1)"
                : "rgba(37, 124, 109, 1)",
            "&.Mui-disabled": {
              color: "#fff",
            },
          }}
        >
          {okText}
          {confirmModalLoading && (
            <CircularProgress
              size={16}
              sx={{
                color: "#fff",
                ml: "8px",
              }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
